export default "../css/33907c3265998371bea9323e2a6bdf99.ttf";